import { SlideOver } from '../common/SlideOver';
import { columnsFor } from '../../lib/exploreColumns';
import type { FilterControl } from '../../lib/exploreColumns';
import { ColumnFilterControl } from './ColumnFilterControl';
import { useExploreStore } from '../../store/exploreStore';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function FilterSheet({ open, onClose }: Props) {
  const { kind, filterSpec, setFilter, clearFilter, sportOptions } = useExploreStore();
  const filterableCols = columnsFor(kind).filter((col) => !!col.filter);
  // Inject the dynamically-fetched Blast sport options (mirrors ExploreGrid's header logic).
  const controlFor = (f: FilterControl): FilterControl =>
    f.type === 'enum' && f.axis === 'sports' ? { ...f, options: sportOptions } : f;

  const footer = (
    <div className="flex gap-2 justify-end">
      <button
        type="button"
        className="btn-secondary"
        onClick={clearFilter}
      >
        Clear all
      </button>
      <button
        type="button"
        className="btn-primary"
        onClick={onClose}
      >
        Apply
      </button>
    </div>
  );

  return (
    <SlideOver isOpen={open} onClose={onClose} title="Filters" footer={footer}>
      <div className="flex flex-col gap-5">
        {filterableCols.map((col) => (
          <div key={col.key} className="flex flex-col gap-1.5">
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
              {col.label}
            </span>
            <ColumnFilterControl
              control={controlFor(col.filter!)}
              spec={filterSpec}
              onChange={setFilter}
            />
          </div>
        ))}
        {filterableCols.length === 0 && (
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">
            No filters available for this view.
          </p>
        )}
      </div>
    </SlideOver>
  );
}
